import { useEffect, useState } from 'react'
import { api, session } from '../api.js'

export default function Parametres() {
  const [org, setOrg] = useState(null)
  const [message, setMessage] = useState('')

  useEffect(() => { api.org().then(setOrg) }, [])
  if (!org) return <p className="chargement">Chargement…</p>

  const tarif = org.population < 500 ? 39 : org.population < 2000 ? 69
    : org.population < 5000 ? 119 : 199

  async function sauver(champs) {
    setOrg({ ...org, ...champs })
    await api.saveOrg(champs)
    setMessage('Enregistré.')
  }

  return (
    <>
      <h1>Paramètres</h1>
      <p className="chapo">Les informations de la collectivité et l'état de votre espace.</p>
      {message && <p className="succes" role="status">{message}</p>}

      <div className="deux">
        <section className="carte">
          <h2>La collectivité</h2>
          <div className="champ">
            <label htmlFor="nom">Nom affiché sur le portail</label>
            <input id="nom" defaultValue={org.name}
                   onBlur={(e) => e.target.value !== org.name && sauver({ name: e.target.value })} />
          </div>
          <div className="champ">
            <label htmlFor="pop">Population</label>
            <input id="pop" type="number" defaultValue={org.population}
                   onBlur={(e) => sauver({ population: Number(e.target.value) })} />
          </div>
          <dl className="infos-liste">
            <div><dt>Adresse du portail</dt><dd className="mono">{org.slug}</dd></div>
            <div><dt>Type</dt><dd>{org.kind === 'agglo' ? 'Intercommunalité' : 'Commune'}</dd></div>
            {org.parent && <div><dt>Rattachée à</dt><dd>{org.parent}</dd></div>}
            <div><dt>Mise en ligne</dt><dd>{org.published_at
              ? new Date(org.published_at).toLocaleDateString('fr-FR') : 'jamais publiée'}</dd></div>
          </dl>
        </section>

        <aside>
          <div className="carte">
            <h2>Abonnement</h2>
            <p className="plan">Formule {org.plan}</p>
            <p className="tarif">{tarif} € <span>par mois</span></p>
            <p className="aide">Tarif indexé sur la population. Démarches illimitées, hébergement
              en France, mises à jour comprises.</p>
          </div>

          <div className="carte">
            <h2>Votre espace</h2>
            <dl className="infos-liste">
              <div><dt>Démarches en ligne</dt><dd>{org.counters.forms}</dd></div>
              <div><dt>Dossiers reçus</dt><dd>{org.counters.requests}</dd></div>
              <div><dt>Courriels envoyés</dt><dd>{org.counters.outbox}</dd></div>
            </dl>
          </div>

          <div className="carte">
            <h2>Session</h2>
            <p className="aide">Vous travaillez sur la version
              {session.env === 'draft' ? ' brouillon' : ' en ligne'}.</p>
            <button className="btn" onClick={() => { session.clear(); window.location.reload() }}>
              Se déconnecter
            </button>
          </div>
        </aside>
      </div>
    </>
  )
}
